/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Versions_Tool_File_RenameInputs */



/**
* | output |
* | --- |
* | "Linked file renamed" |
*
* @param {Canvas_Versions_Tool_File_RenameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_tool_file_rename = /** @type {((inputs?: Canvas_Versions_Tool_File_RenameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_Tool_File_RenameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfte Datei umbenannt")
	return /** @type {LocalizedString} */ ("Linked file renamed")
});